import { Circle, Fill, Icon, Stroke, Style, Text } from "ol/style";
import { USERINPUTTYPE } from "../../userinput/userinput";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import View from "ol/View";
import Map from "ol/Map";
import Feature from "ol/Feature";
import { Modify, Snap } from "ol/interaction";
import { LineString, Point } from "ol/geom";
import { Collection } from "ol";
import { toLonLat } from "ol/proj";
import Projection from "ol/proj/Projection";
import LayerGroup from "ol/layer/Group";
import { STREAMTYPE } from "../../measure/internal";
import { EdgeDirection } from "../../graph/edge/EdgeDirection";
import { combineLatest as observableCombineLatest, Observable, Subject } from "rxjs";
import Overlay from "ol/Overlay";
import { isDefined } from "../../../infra3d/utils/seidel/util";
export class AxisscaleBar {
    constructor(container, navigator) {
        this._minimal_axis_length = 1000;
        this._panorotation = 0;
        this._panorotationevt = -1;
        this._actPosCoords = [0, 0];
        this._showdirectionmode = "viewingdirection_binary"; // options are "reversemode", "viewingdirection_seamless", "viewingdirection_binary"
        this._navigator = navigator;
        this._scene = container.scene;
        this._notifyAxisscaleBarLoaded$ = new Subject();
    }
    activate(container, axisscalebarConfiguration) {
        this._container = container;
        this._axisscalebarConfiguration = axisscalebarConfiguration;
        this._axisStyle = {
            LineString: new Style({
                stroke: new Stroke({
                    color: this._axisscalebarConfiguration.axiscolor,
                    width: 4,
                    lineCap: "butt",
                }),
                text: new Text({
                    font: this._axisscalebarConfiguration.font,
                    rotation: 0,
                    offsetX: this._axisscalebarConfiguration.labelOffset,
                    textAlign: "left",
                }),
                zIndex: 0,
            }),
            Point: new Style({
                image: new Icon({
                    src: "data:image/svg+xml;utf8," +
                        '<svg width="50" height="35" viewBox="0 0 2 2" xmlns="http://www.w3.org/2000/svg">' +
                        '<line x1="1" y1="0" x2="1" y2="2" stroke="%23272727" stroke-width="0.3"/>' +
                        "</svg>",
                    scale: 0.3,
                }),
                text: new Text({
                    font: this._axisscalebarConfiguration.font,
                    rotation: 0,
                    offsetX: this._axisscalebarConfiguration.labelOffset,
                    offsetY: -16,
                    textAlign: "center",
                }),
                zIndex: 0,
            }),
            AxisPoint: new Style({
                image: new Circle({
                    radius: this._axisscalebarConfiguration.axispoint_radius,
                    fill: new Fill({
                        color: this._axisscalebarConfiguration.axiscolor,
                    }),
                }),
                text: new Text({
                    font: this._axisscalebarConfiguration.font,
                    rotation: 0,
                    offsetY: -16,
                    offsetX: this._axisscalebarConfiguration.labelOffset,
                    textAlign: "center",
                }),
            }),
        };
        this._actposStyle = {
            normal: new Style({
                image: new Icon({
                    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsAAAA7AAWrWiQkAAANqSURBVFhH7ZZLSJRRGIbP3JImskUZNtPg4CCIMoiSLgbaRO0s3czGwI2LNjWCi8CFkAi6yujfCzGQYtBGkagxrYW0EAm8kMKUoZFi2CK62dx63zNnRouZcc4E0uJ/4Jvv3M97vvP5H4WJiYmJicn/QSqVciSTSSfsFD3qFtVuQd0Hf1wO1EQu8i9gcxfcRZgfZodZ2QxBPywWyyuUz6u+z7CHVqv1HXzRlCwQwk5CwDUIaYFXrYXB2BTcNGwGQr/LxkMoSSDElcN1Q9gZ1rnv+vo6LcSyz+czvF6vyCccY3bhHkDkRrolP9oCsfgx2E1sXpVIJMTCwoLo7OwMqe4/CIfDRnNzc1bo5uam2Nvb4wFYZRq8QN9TCP0pB+SA+aIFoneF4hgpCAjlE0fYNzExIaNK3G63GB0dDdGwDnRZL6H5NspeOSAHWhHERuWwOxBom5ubE11dXXnFHQSCjKamJlmORqOitbVVzpucnDRqamq4bhJrzqBpGv4H+zJoCYzH4y02m+06y7W1tUWJy7C6umrQMy3q6+uzc3t7e0VHR4fhcDh4O7sQGEZk36tuvSvGRJk8i4uLsq7Dzs6O9Dig9BmGhoaE3+8Pra2tcf3TaOqG0KuIqvxu6ubgWf5sb29rRY+srKxk5/T09KjSPm1tbdncRBQvQyBzs0pLIHNFeVnXwW63yysuhNPplB7rcwN+JxNaAnGyT/Qul+vQzf4GOatKQgwPD6vSPrOzs0Z7e7uBPRiEKdg9XPkH3SuO8qeurk5WdKioqJA+FotJn2FgYEAsLy8blZWVDNwGBN6FsAgszn5dgW+wSIyJPjIyUnQUx8fHs2ORv6okRCQSMYLBoAExjNoT2H1GTXYqtARi8jec8DlTJBAIiP7+ftWTn8HBQdHQ0KBq8nUJ9fX1iaWlJcPj8TDfNvDp4XXyRZFRO4j2U4e/LAcWvYXF5GsyPz+f96kbGxszGhsbVU3I9xoHFHynMZdPXQT1Z7mEZdAWSCCS/8ncQNGTbkm/EFtbW7LMJ626ulqWcwFhHzH/MUzmdCFKEkggsgwbBbHJBVhR62A8Px8vMXwK9ivdWpiSBWbgxxQuAOODzw9ZGewr7AvsNTSd4yHg+Yw9wnW+RfvRAwE2RhV2AsY8lYenR93NNjnQxMTExMTkCBHiN+yhjgr0Tr75AAAAAElFTkSuQmCC",
                    scale: 1.0,
                    anchor: [0.5, 0.5],
                }),
                zIndex: 1,
            }),
            hover: new Style({
                image: new Icon({
                    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsAAAA7AAWrWiQkAAAPaSURBVFhH7ZZdbFRFFMfP3Nstsdv9aHZb2tvd1PJgSXwh8oYQIKiJmhR9aBv7RAwP+rI2JUJMXHBt0sYE9+GGrwgvklBoUPAjxKTW1EIgUQNqoBaoLrq1H0tLP9JtK7vdO54zzLaFdHGnJg0P95fczJm5M3P/97/nnlmwsbGxsbF5MuCcOyzLKsLLQy32mRxn1p0Njdg+JSYqIjb5P6AYA0Z2NUKBsRZAw/2YhrIs4PPzkO4fAL3UA3p5GfC5OSj96LimaTG5NC9WLBCFuVhi99tcD1Qylt826CJA6uYfYJw5gUJn5fBjWZFAFOeG0b3vMc1ZRH168OTkJFyL14Yo3lj1ten1eiGXcG7NzqKbR1FkXA7lRFkgCijkiab3me6lXIPh4WHY0XApJG8/xHcdW0zDMBaETk1NQSaTgZKSEuzhm6T6/wSj/RgK/UdMWAbMFzX4YMNbJI6c+vRCdSiXOILufXXlOeEq4Xa74dAZf6i98xkcQ91raqphdN8H+KJPiwnLoOQgPsjNR8MRxnQtPhCHl964klPcUrrPbjUrKipEPD4+DptqO8W6y1++aPp8PtqXs/TtO2Cc/gTdnhMTJUoO8vgL9SSO4nzFEdvrehbmUm5meX7ntyH6FdBBBoU16/jdd/c/6qbaT+wIUvJAIpEQXRVmZmZEi/km2ixtbW3w7NazobF7Y1ig8KMbO9BkDTa8g6aKuqkmUHM5qfl18PW83cvyY+yVhTXNzc0yWmTzzq7F3Cxcj27uO4BuVqkJ5JbI9mzSq7DOc9KUYU6KikTVerA/T6cxzCgKTIriuiH4xX8+7FH8Pr+MAKLRqIwW+embV83XNv9iYkXC8nP9NpR9HMF0+FtNYHrgHjWl/lLRVcHpFNkh6uBSWlpa4LeL9WZxcTHwDBZKf+SgFjh/GMXN0301gcGuDs4zFiV65+lNebv4/efbFuYmk0kZAfxw4WWzbnuvdO1GP5RFPyTX5G2BkkBcPMPSt2KUI8FAECKRiLyTm9bWVihfWy57IAp1OByG3p460+PxCNfmveGoFjh3KOvaUpSPOvyyHHC3Kcz0EnGaDA0N5Tzquj/DAl3+oEATExMT4tijWohr0bW+GBgdR5YTlkVZIIEiXWx0z17Q8OyS0AkxnZwWsdvlluft8nBreprN9vSx6qun5FBOViSQQJFrYGR3ExQEDIW/WxzSv//FjFOHcU1KDj+WFQvMQsUURt6sB92HZ5jDAUwvAJ5KAb9/H9KxYdB8LjyBDKC/WHPdvVr1z+1y6eqC5ujkKl5OvBzYFy9PLfYraUxMtLGxsbGxWUUA/gWuiKbIUg4UBwAAAABJRU5ErkJggg==",
                    scale: 1.0,
                    anchor: [0.5, 0.5],
                }),
                zIndex: 1,
            }),
        };
        this._showdirectionmode = axisscalebarConfiguration.showdirectionmode;
        this._minimal_axis_length = axisscalebarConfiguration.width;
        this._subscribeEvents();
        this._initMap(container);
        this._calculateScalebarFeatures(this._scene.getLRHandler().getActiveNavigationAxis());
        const _geoframecollection$ = new Observable((observer) => {
            this._scene.userInputHandler.subscribeEvent(USERINPUTTYPE.GEOFRAMECOLLECTIONCHANGED, (geoframecollection) => {
                observer.next(geoframecollection);
            }, this);
        });
        const _axischanged$ = new Observable((observer) => {
            this._scene.userInputHandler.subscribeEvent(USERINPUTTYPE.NAVIGATION_AXISCHANGED, (axis) => {
                observer.next(axis);
            }, this);
        });
        observableCombineLatest([
            this._navigator.playService.direction$,
            _geoframecollection$,
            _axischanged$,
        ]).subscribe(([direction, gfcollection, axis]) => {
            const current_geoframe = this._scene.getCurrentGeoframe();
            let next_geoframe = null;
            if (direction == EdgeDirection.Next) {
                if (gfcollection.geoframearray.length > current_geoframe.getFramenumber() + 1)
                    next_geoframe = gfcollection.geoframearray[current_geoframe.getFramenumber() + 1];
            }
            else {
                if (current_geoframe.getFramenumber() - 1 >= 0)
                    next_geoframe = gfcollection.geoframearray[current_geoframe.getFramenumber() - 1];
            }
            let direction_on_axis = "forward";
            if (axis && next_geoframe) {
                const current_uvw = axis.xyz2uvw(current_geoframe.easting, current_geoframe.northing, current_geoframe.height);
                if (current_uvw) {
                    const current_abs_u = axis.u2absU(current_uvw.featureidx, current_uvw.lrcoords[0]);
                    const future_uvw = axis.xyz2uvw(next_geoframe.easting, next_geoframe.northing, next_geoframe.height);
                    if (future_uvw) {
                        const future_abs_u = axis.u2absU(future_uvw.featureidx, future_uvw.lrcoords[0]);
                        if (future_abs_u > current_abs_u) {
                            direction_on_axis = "forward";
                        }
                        else {
                            direction_on_axis = "backward";
                        }
                    }
                }
            }
            if (this._showdirectionmode == "reversemode") {
                if (direction_on_axis == "forward") {
                    this._actposStyle.normal.getImage().setRotation(0);
                    this._actposStyle.hover.getImage().setRotation(0);
                }
                else {
                    this._actposStyle.normal.getImage().setRotation(Math.PI);
                    this._actposStyle.hover.getImage().setRotation(Math.PI);
                }
                this._drawActualPos();
            }
        });
    }
    get axisscaleBarLoaded$() {
        return this._notifyAxisscaleBarLoaded$;
    }
    /**
     * Subscribe all Events
     * @private
     */
    _subscribeEvents() {
        this._axischangeevt = this._scene.userInputHandler.subscribeEvent(USERINPUTTYPE.NAVIGATION_AXISCHANGED, (axis) => {
            this._calculateScalebarFeatures(axis);
        }, this);
        this._geoframechangeevt = this._scene.userInputHandler.subscribeEvent(USERINPUTTYPE.GEOFRAMECHANGED, (geoframe) => {
            this._movePointer(geoframe);
        }, this);
        this._panorotationevt = this._scene.userInputHandler.subscribeEvent(USERINPUTTYPE.PANO_ROTATION, (lat, lon) => {
            if (Math.abs(this._panorotation - lon) > 2) {
                this._panorotation = lon;
                this._drawActualPos();
            }
        }, this);
    }
    /**
     * Calculates the needed data from the actual axis.
     * @private
     */
    _calculateScalebarFeatures(axis) {
        if (!axis) {
            this._clearDrawing();
            return;
        }
        if (!axis.isnavigationref) {
            this._clearDrawing();
            return;
        }
        this._length_array = [];
        for (const feature of axis.axis.features) {
            let len = 0;
            const coords = feature.geometry.coordinates;
            for (let j = 0; j < coords.length - 1; j++) {
                len += Math.sqrt(Math.pow(coords[j + 1][0] - coords[j][0], 2) + Math.pow(coords[j + 1][1] - coords[j][1], 2));
            }
            this._length_array.push(len);
        }
        const axlen = this._length_array.reduce((a, b) => a + b);
        if (axlen < this._minimal_axis_length / 2) {
            this._setMapResolution(axlen);
        }
        else {
            this._setMapResolution();
        }
        // KM-Striche
        const coords = [];
        const sd = this._axisscalebarConfiguration.km_stroke_dist;
        for (let i = 0; i < axis.axis.features.length; i++) {
            const feature = axis.axis.features[i];
            const length_ist = this._length_array[i];
            const fp = feature.properties;
            const min_u = isDefined(axis.offsetattribute)
                ? isDefined(fp[axis.offsetattribute])
                    ? fp[axis.offsetattribute]
                    : 0
                : 0;
            const length_soll = isDefined(axis.nominallengthattribute)
                ? isDefined(fp[axis.nominallengthattribute])
                    ? fp[axis.nominallengthattribute]
                    : length_ist
                : length_ist;
            const max_u = min_u + length_soll;
            for (let k = Math.ceil(min_u / sd); k <= Math.floor(max_u / sd); k++) {
                const u_strich = k * sd;
                coords.push([axis.u2absU(i, u_strich), 0, u_strich]);
            }
        }
        this._recenterMap(axis);
        this._calcFeatures(coords, axis);
        this._movePointer(this._scene.getCurrentGeoframe());
        this._notifyAxisscaleBarLoaded$.next(true);
    }
    /**
     * Initializes the Map
     * @private
     */
    _initMap(container) {
        this._map = new Map({
            target: container,
            layers: [],
            interactions: [],
            view: new View({
                center: [0, 0],
                resolution: 0.75,
            }),
            controls: [],
        });
    }
    /**
     * Adds all needed interactions to the map.
     * @private
     */
    _addInteractions() {
        this._map
            .getInteractions()
            .getArray()
            .slice(0)
            .forEach((interaction) => {
            this._map.removeInteraction(interaction);
        });
        if (this._actposFeature) {
            const modifyInteraction = new Modify({
                features: new Collection([this._actposFeature]),
                style: this._actposStyle["hover"],
                pixelTolerance: 10,
            });
            modifyInteraction.on("modifyend", (modifyEvt) => {
                this._movePosition(modifyEvt.mapBrowserEvent.coordinate[0]);
            });
            this._map.addInteraction(modifyInteraction);
        }
        this._map.on("click", (evt) => {
            this._movePosition(evt.coordinate[0]);
        });
        const tooltip_element = document.createElement("div");
        tooltip_element.className = "axisscalebar-tooltip";
        const overlay = new Overlay({
            id: 1,
            element: tooltip_element,
            autoPan: false,
            offset: [-20, -63],
            positioning: "bottom-center",
        });
        const old_overlay = this._map.getOverlayById(1);
        if (overlay)
            this._map.removeOverlay(old_overlay);
        this._map.addOverlay(overlay);
        this._map.on("pointermove", (evt) => {
            const axis = this._scene.getLRHandler().getActiveNavigationAxis();
            if (!axis)
                return;
            const absU = evt.coordinate[0];
            const overlay = this._map.getOverlayById(1);
            if (absU < 0 || absU > this._length_array.reduce((a, b) => a + b)) {
                overlay.setPosition(undefined);
                return;
            }
            this._map.getTargetElement().style.cursor = "pointer";
            overlay.setPosition([absU, 0]);
            const [u, featureidx] = axis.absU2u(absU);
            const axisid_obj = axis.getAxisIdentifier(featureidx);
            const axisid = Object.keys(axisid_obj)
                .map((x) => {
                return axisid_obj[x];
            })
                .slice(-1);
            let formatted_u = u.toFixed(0) + "m";
            if (u > 1000) {
                formatted_u = (u / 1000).toFixed(2) + "km";
            }
            overlay.getElement().innerHTML = axisid + " " + formatted_u;
        });
        this._map.getTargetElement().onmouseout = () => {
            this._map.getOverlayById(1).setPosition(undefined);
        };
        const axislinefeature = [
            new Feature(new LineString([
                [0, 0],
                [this._length_array.reduce((a, b) => a + b), 0],
            ])),
        ];
        const snapInteraction = new Snap({
            features: new Collection([axislinefeature[0]]),
            pixelTolerance: 100000,
            edge: true,
            vertex: false,
        });
        this._map.addInteraction(snapInteraction);
    }
    /**
     * Moves the pointer to the Actual position and checks, if the map has to be recentered. If so, it does a recenter.
     * @private
     */
    _movePointer(geoframe) {
        const axis = this._scene.getLRHandler().getActiveNavigationAxis();
        if (!axis) {
            return;
        }
        const uvw = axis.xyz2uvw(geoframe.easting, geoframe.northing, geoframe.height);
        if (!uvw) {
            return;
        }
        const absU = axis.u2absU(uvw.featureidx, uvw.lrcoords[0]);
        this._actPosCoords = [absU, 0];
        if (!(geoframe.getMeasureInfo().streamtype === STREAMTYPE.CALOTTE ||
            geoframe.getMeasureInfo().streamtype === STREAMTYPE.CUBEMAP)) {
            this._panorotation = 0;
        }
        else {
            this._panorotation = geoframe.parentGeoFrameCollection.getLatLon()[1];
        }
        this._drawActualPos();
        // Recenter the map, if the pointer gets to the end.
        const currentextent = this._map.getView().calculateExtent(this._map.getSize());
        const currentlength = currentextent[2] - currentextent[0];
        if (currentextent[0] + currentlength * 0.1 > this._actPosCoords[0] ||
            currentextent[2] - currentlength * 0.1 < this._actPosCoords[0]) {
            this._recenterMap(axis, this._actPosCoords[0]);
        }
    }
    _drawActualPos() {
        const axis = this._scene.getLRHandler().getActiveNavigationAxis();
        if (!axis) {
            return;
        }
        const geoframe = this._scene.getCurrentGeoframe();
        //calc direction
        let linear_orientation = Math.PI / 2;
        const azi = geoframe.getHorizontalOrientation() + this._panorotation;
        const future_easting = geoframe.easting + 5 * Math.sin((azi * Math.PI) / 180);
        const future_northing = geoframe.northing + 5 * Math.cos((azi * Math.PI) / 180);
        const future_uvw = axis.xyz2uvw(future_easting, future_northing, geoframe.height);
        if (future_uvw) {
            const future_abslolute_u = axis.u2absU(future_uvw.featureidx, future_uvw.lrcoords[0]);
            const future_v = future_uvw.lrcoords[1];
            linear_orientation = Math.atan2(future_abslolute_u - this._actPosCoords[0], -(future_v - this._actPosCoords[1]));
        }
        if (this._actposFeature) {
            this._actposFeature.getGeometry().setCoordinates([this._actPosCoords[0], 0]);
        }
        else {
            this._actposFeature = new Feature({
                geometry: new Point([this._actPosCoords[0], 0]),
                name: "actposFeature",
            });
            const actposSource = new VectorSource({
                features: [this._actposFeature],
            });
            const actposLayer = new VectorLayer({
                source: actposSource,
                style: this._actposStyle["normal"],
                zIndex: 1,
            });
            actposLayer.setProperties({ name: "actposLayer" });
            this._map.addLayer(actposLayer);
            this._addInteractions();
        }
        if (this._showdirectionmode == "viewingdirection_binary") {
            if (linear_orientation >= 0 && linear_orientation < Math.PI) {
                this._actposStyle.normal.getImage().setRotation(0);
                this._actposStyle.hover.getImage().setRotation(0);
            }
            else {
                this._actposStyle.normal.getImage().setRotation(Math.PI);
                this._actposStyle.hover.getImage().setRotation(Math.PI);
            }
        }
        if (this._showdirectionmode == "viewingdirection_seamless") {
            this._actposStyle.normal.getImage().setRotation(linear_orientation - Math.PI / 2);
            this._actposStyle.hover.getImage().setRotation(linear_orientation - Math.PI / 2);
        }
    }
    /**
     * Calculates the Feature Collection. The Feature Collection contains all elements except of the
     * pointer of the acutal position.
     * @param { number[][] } coords
     * @param { Axis } axis
     * @private
     */
    _calcFeatures(coords, axis) {
        const axislinefeature = [
            new Feature({
                geometry: new LineString([
                    [0, 0],
                    [this._length_array.reduce((a, b) => a + b), 0],
                ]),
                name: "axisfeature",
            }),
        ];
        if (this._axisscalebarConfiguration.km_stroke) {
            for (const coord of coords) {
                let label = "";
                if (coord[2] %
                    (this._axisscalebarConfiguration.stroke_label *
                        this._axisscalebarConfiguration.km_stroke_dist) ==
                    0) {
                    label = (coord[2] / 1000).toFixed(this._axisscalebarConfiguration.labelaccuracy);
                }
                axislinefeature.push(new Feature({
                    geometry: new Point([coord[0], coord[1]]),
                    label: label,
                }));
            }
        }
        const axispointfeature = [];
        if (this._axisscalebarConfiguration.labelattribute) {
            let km_absolut_sum = 0;
            for (let i = 0; i < axis.axis.features.length; i++) {
                axispointfeature.push(new Feature({
                    geometry: new Point([km_absolut_sum, 0]),
                    name: "Axpoint",
                    label: axis.axis.features[i].properties[this._axisscalebarConfiguration.labelattribute],
                }));
                km_absolut_sum += this._length_array[i];
            }
        }
        // Update the Interactions
        this._addInteractions();
        this._addLayers(axislinefeature, axispointfeature, axis);
    }
    /**
     * Calculates the VectorSource and VectorLayer of the linref features (except of the acutal position pointer).
     * @private
     */
    _addLayers(axislinefeature, axispointfeature, axis) {
        const layers = this._map.getLayerGroup().getLayers().getArray();
        layers.forEach((layer) => {
            if (layer.getProperties().name !== "actposLayer" && layer.getProperties().name !== "labelleft") {
                this._map.removeLayer(layer);
            }
        });
        const axislineSource = new VectorSource({
            features: axislinefeature,
        });
        const axislineLayer = new VectorLayer({
            source: axislineSource,
            style: (feature) => {
                if (feature.getGeometry().getType() === "Point") {
                    const style = this._axisStyle[feature.getGeometry().getType()];
                    if (!this._axisscalebarConfiguration.labelattribute) {
                        style.getText().setText(feature.getProperties().label.toString());
                    }
                    return style;
                }
                else {
                    return this._axisStyle[feature.getGeometry().getType()];
                }
            },
        });
        const axispointSource = new VectorSource({
            features: new Collection(axispointfeature),
        });
        const axispointLayer = new VectorLayer({
            source: axispointSource,
            renderBuffer: 2000,
        });
        axispointLayer.setStyle((feature) => {
            const style = this._axisStyle["AxisPoint"];
            style.getText().setText(feature.getProperties().label.toString());
            return style;
        });
        const layergroup = new LayerGroup({
            layers: [axispointLayer, axislineLayer],
        });
        this._map.addLayer(layergroup);
    }
    /**
     * Moves the position to the given u, v, and w values. Calculates the lon/lat and moves to the nearest geoframe.
     * @param u { number }
     * @private
     */
    _movePosition(u) {
        const axis = this._scene.getLRHandler().getActiveNavigationAxis();
        if (axis == null)
            return;
        let v = axis.xyz2uvw(this._scene.getCurrentGeoframe().easting, this._scene.getCurrentGeoframe().northing, this._scene.getCurrentGeoframe().height).lrcoords[1];
        if (v < 0) {
            v -= 1;
        }
        else {
            v += 1;
        }
        const absU2u = axis.absU2u(u);
        u = absU2u[0];
        const xyz = axis.uvw2xyz(absU2u[1], u, v, 0);
        let srid;
        if (axis.axis.crs.properties.code) {
            srid = axis.axis.crs.properties.code.toString();
        }
        else {
            srid = axis.axis.crs.properties.name.slice(5);
        }
        const lonlat = toLonLat([xyz[0], xyz[1]], new Projection({ code: "EPSG:" + srid }));
        const latlon = {
            lat: lonlat[1],
            lon: lonlat[0],
        };
        const moveToclosest = () => {
            const geoframearray = this._scene.getCurrentGeoFrameCollection().geoframearray;
            const dist_first_geoframe = Math.sqrt(Math.pow(geoframearray[0].easting - xyz[0], 2) + Math.pow(geoframearray[0].northing - xyz[1], 2));
            const dist_last_geoframe = Math.sqrt(Math.pow(geoframearray[geoframearray.length - 1].easting - xyz[0], 2) +
                Math.pow(geoframearray[geoframearray.length - 1].northing - xyz[1], 2));
            let key;
            if (dist_first_geoframe < dist_last_geoframe) {
                key = geoframearray[0].key;
            }
            else {
                key = geoframearray[geoframearray.length - 1].key;
            }
            const reply = this._navigator.moveToKey$(key);
            reply.subscribe((node) => undefined, (e) => {
                console.error(e);
            });
        };
        const reply = this._navigator.movePosition$(latlon);
        reply.subscribe((x) => undefined, (e) => {
            console.warn(e);
            moveToclosest();
            this._movePointer(this._scene.getCurrentGeoframe());
        });
    }
    _clearDrawing() {
        if (this._map)
            this._map
                .getLayers()
                .getArray()
                .slice(0)
                .forEach((layer) => this._map.removeLayer(layer));
        this._actposFeature = null;
        this._notifyAxisscaleBarLoaded$.next(false);
    }
    _setMapResolution(width) {
        const axiswidth = width || this._minimal_axis_length;
        this._map.getView().setResolution(axiswidth / this._map.getSize()[0]);
    }
    resize() {
        this._map.updateSize();
        this._setMapResolution();
        this._calculateScalebarFeatures(this._scene.getLRHandler().getActiveNavigationAxis());
    }
    deactivate() {
        this._clearDrawing();
        if (this._map)
            this._map.getTarget().innerHTML = "";
        this._scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.NAVIGATION_AXISCHANGED, this._axischangeevt);
        this._scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.GEOFRAMECHANGED, this._geoframechangeevt);
        this._scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.PANO_ROTATION, this._panorotationevt);
    }
    _recenterMap(axis, x) {
        if (!x) {
            const uvw = axis.xyz2uvw(this._scene.getCurrentGeoframe().easting, this._scene.getCurrentGeoframe().northing, this._scene.getCurrentGeoframe().height);
            if (!uvw) {
                return;
            }
            x = axis.u2absU(uvw.featureidx, uvw.lrcoords[0]);
        }
        const current_resolution = this._map.getView().getResolution();
        const panel_height_m = current_resolution * this._map.getSize()[1];
        const y_offset_m = current_resolution * this._axisscalebarConfiguration.centerOffsetY;
        this._map.getView().setCenter([x, panel_height_m / 2 - y_offset_m]);
    }
}
//# sourceMappingURL=AxisscaleBar.js.map